import { render, staticRenderFns } from "./GlobalAutoTooltip.vue?vue&type=template&id=71f79080&"
import script from "./GlobalAutoTooltip.vue?vue&type=script&lang=js&"
export * from "./GlobalAutoTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports